module.exports = __webpack_public_path__ + "static/media/PN_Newsletter-662-V2.c0c965df.jpg";